import cx from "classnames";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Column, Container, format, Row } from "@gamedev-web/gamedev-sdk-core";
import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import * as commonStyles from "../../components/commonStyles/commonStyles.module.css";
import { getImage, ImageType } from "../../helpers/imageHelper";
import { useMinPageHeight } from "../../helpers/windowHelpers";
import { useStrings } from "../../localization/localizationHelpers";
import { getCurrentError } from "../../redux/selectors";
import { useCv } from "../../telemetry/error";
import * as styles from "./ErrorPage.module.css";

export const ErrorPage = () => {
  const [errorNumber, somethingWentWrong, errorPageFootNote, contactSupport, cvErrorPageNote] =
    useStrings(
      "errorNumber",
      "somethingWentWrong",
      "errorPageFootNote",
      "contactSupport",
      "cvErrorPageNote"
    );
  const error = useSelector(getCurrentError);
  const minPageHeight = useMinPageHeight();
  const cv = useCv();
  const [cvNote, setCvNote] = useState("");

  useEffect(() => {
    if (cv && !cvNote) {
      setCvNote(format(cvErrorPageNote, cv));
    }
  }, [cv, cvNote, cvErrorPageNote]);

  if (!error) {
    return null;
  }

  const mainMessage = format(errorNumber, error.code.toString());

  return (
    <Container
      className={cx(commonStyles.pageContainer, styles.errorPageContainer)}
      style={{ minHeight: minPageHeight }}
    >
      <Row>
        <Column className={styles.columnWrapper}>
          <Row className={styles.contentBox}>
            <Column>
              <img
                src={getImage("errorpage", ImageType.Png)}
                alt={"error"}
                className={styles.image}
              />
            </Column>
            <Column className={styles.contentColumn}>
              <div>
                <h1>{mainMessage}</h1>
                <h2>{somethingWentWrong}</h2>
                <p>{errorPageFootNote}</p>
                {cvNote && <p>{cvNote}</p>}
                <BasicButton
                  as={"a"}
                  buttonType={ButtonType.Brand}
                  className={styles.supportButton}
                  href={`mailto:idsetup@xbox.com`}
                >
                  {contactSupport}
                </BasicButton>
              </div>
            </Column>
          </Row>
        </Column>
      </Row>
    </Container>
  );
};
